import { matchJoin, useRouter } from './lib/router';
import HostPage from './pages/HostPage';
import JoinPage from './pages/JoinPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  const { path } = useRouter();

  const joinCode = matchJoin(path);
  if (joinCode !== null) return <JoinPage rawCode={joinCode} />;
  if (path === '/' || path === '') return <HostPage />;
  return <NotFoundPage />;
}
